<template>
    <div class="address-list-entry">
        <h4 class="entry-title">{{ title }}</h4>
        <AddressIconBar :item="item" />
        <p class="entry-teaser">{{ stripHtml(item.$.description) }}</p>
    </div>
</template>

<script lang="ts" setup>
import { Address } from '@/models/Address';
import { computed } from 'vue';
import AddressIconBar from './AddressIconBar.vue';
import { stripHtml } from '@/helpers/tools';

const props = defineProps({
    item: {
        type: Address,
        required: true,
    },
});

const title = computed(() => props.item.displayTitle || props.item.title);
</script>

<style lang="scss" scoped>
.address-list-entry {
    max-width: 350px;
    .icon {
        margin: 0;
    }
    .entry-title {
        font-size: 1rem;
        color: var(--nearblack-color);
        margin: 0;
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;
        border-bottom: 1px solid var(--gray-border-color);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .entry-teaser {
        font-size: 0.875rem;
        color: var(--gray-text-color);
        margin: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>
